import { useGetBalance, useUpdateBalance } from './useBalanceAccounts';
import { useBulkInviteUpload } from './useBulkInviteUpload';
import { useBulkBusinessCardsUpload, useBusinessCards } from './useBusinessCards';
import {
  useAddCommunity,
  useCommunities,
  useCommunity,
  useDeleteCommunity,
  useEditCommunity,
} from './useCommunitites';
import { useConfiguration, useEditConfiguration } from './useConfiguration';
import { useCustomIjmondExport } from './useCustoms';
import {
  useAddDriverBalance,
  useAddDriversLicense,
  useDataProtection,
  useDriver,
  useDrivers,
  useEditDriver2FA,
  useEditDriverDashboardAccess,
  useEditDriverDetails,
  useEditDriverOrganistaion,
  useEditDriverPaymentInstrument,
  useEditDriverPersonalInformation,
  useEditDriverVerified,
  useEditProviderMeta,
  useExportDrivers,
  useRemitDriverInvoices,
  useSendDriverInvite,
  useSetUserRole,
  useSyncGreenwheels,
} from './useDrivers';
import { useFleets } from './useFleets';
import { useExportInvitations, useInvitations } from './useInvitations';
import { useEditMerchantCategoryCodes, useMerchantCategoryCodes } from './useMerchantCategoryCodes';
import { useAddMetaRule, useDeleteMetaRule, useEditMetaRule, useMetaRules } from './useMetaRules';
import {
  useAddOrganisation,
  useAddUser,
  useDownloadBulkInvites,
  useEditAFAS,
  useEditOrganisation,
  useExportOrganisation,
  useHasBulkInvites,
  useOrganisation,
  useOrganisationNames,
  useOrganisations,
  useOrganisationUsage,
  useResendInvites,
  useUpdateOrganisationCommissions,
  useUpdateOrganisationEmailTemplates,
  useUpdateOrganisationMobilityProduct,
  useUpdateOrganisationProviders,
  useUpdateOrganisationUsageFeeConfig,
} from './useOrganisations';
import { useAddProduct, useEditProduct, useProduct, useProducts, useVAT } from './useProducts';
import { useSendPushNotifications } from './usePushNotifications';
import {
  useCancelReservation,
  useCloseReservation,
  useExportReservations,
  useInvoiceReservation,
  useLockVehicle,
  useReservation,
  useReservations,
  useUnlockVehicle,
} from './useReservations';
import {
  useOrganisationStatistics,
  useOrganisationStatisticsCSV,
  useProviderStatistics,
  useReceiptStatistics,
  useReservationStatistics,
  useRevenueStatistics,
  useUserStatistics,
} from './useStatistics';
import { useImpersonation, useSuperAdmins } from './useSuperAdmin';
import {
  useAddTransactionRuleGroup,
  useDeleteTransactionRuleGroup,
  useTransactionRuleGroup,
  useTransactionRuleGroups,
  useUpdateTransactionRuleGroup,
} from './useTransactionRuleGroups';
import {
  useDownloadInvoice,
  useEditTransaction,
  useResetTransaction,
  useTransaction,
  useTransactions,
} from './useTransactions';
import { useTravelCards, useUpdateTravelCardStatus } from './useTravelCard';
import {
  useAddVoucher,
  useDeleteVoucher,
  useEditVoucher,
  useVoucher,
  useVouchers,
} from './useVouchers';

const UseQuery = {
  configuration: useConfiguration,
  transaction: useTransaction,
  transactions: useTransactions,
  superAdmins: useSuperAdmins,
  metaRules: useMetaRules,
  receiptStatistics: useReceiptStatistics,
  userStatistics: useUserStatistics,
  providerStatistics: useProviderStatistics,
  organisation: useOrganisation,
  organisations: useOrganisations,
  reservationStatistics: useReservationStatistics,
  revenueStatistics: useRevenueStatistics,
  drivers: useDrivers,
  driver: useDriver,
  vouchers: useVouchers,
  voucher: useVoucher,
  reservation: useReservation,
  reservations: useReservations,
  travelCards: useTravelCards,
  businessCards: useBusinessCards,
  product: useProduct,
  products: useProducts,
  VAT: useVAT,
  merchantCategoryCodes: useMerchantCategoryCodes,
  community: useCommunity,
  communities: useCommunities,
  fleets: useFleets,
  invitations: useInvitations,
  hasBulkInvites: useHasBulkInvites,
  organisationStatistics: useOrganisationStatistics,
  transactionRuleGroups: useTransactionRuleGroups,
  transactionRuleGroup: useTransactionRuleGroup,
  customIjmondReports: useCustomIjmondExport,
  organisationNames: useOrganisationNames,
  organisationUsage: useOrganisationUsage,
};

const UseMutation = {
  addDriverBalance: useAddDriverBalance,
  editConfiguration: useEditConfiguration,
  editTransaction: useEditTransaction,
  resetTransaction: useResetTransaction,
  downloadInvoice: useDownloadInvoice,
  addMetaRule: useAddMetaRule,
  deleteMetaRule: useDeleteMetaRule,
  useEditMetaRule: useEditMetaRule,
  updateTravelCardStatus: useUpdateTravelCardStatus,
  addVoucher: useAddVoucher,
  editVoucher: useEditVoucher,
  deleteVoucher: useDeleteVoucher,
  exportDrivers: useExportDrivers,
  syncGreenwheels: useSyncGreenwheels,
  cancelReservation: useCancelReservation,
  closeReservation: useCloseReservation,
  lockVehicle: useLockVehicle,
  unlockVehicle: useUnlockVehicle,
  addProduct: useAddProduct,
  editProduct: useEditProduct,
  dataProtection: useDataProtection,
  editMerchantCategoryCodes: useEditMerchantCategoryCodes,
  editOrganisation: useEditOrganisation,
  impersonate: useImpersonation,
  exportOrganisation: useExportOrganisation,
  resendInvites: useResendInvites,
  editAFAS: useEditAFAS,
  addUser: useAddUser,
  sendPushNotifications: useSendPushNotifications,
  getBalance: useGetBalance,
  updateBalance: useUpdateBalance,
  editCommunity: useEditCommunity,
  addCommunity: useAddCommunity,
  deleteCommunity: useDeleteCommunity,
  editDriverOrganisation: useEditDriverOrganistaion,
  editDriverPersonalInformation: useEditDriverPersonalInformation,
  editDriver2FA: useEditDriver2FA,
  editDriverDashboardAccess: useEditDriverDashboardAccess,
  setUserRole: useSetUserRole,
  editDriverDetails: useEditDriverDetails,
  editDriverPaymentInstrument: useEditDriverPaymentInstrument,
  addDriversLicense: useAddDriversLicense,
  editDriverVerified: useEditDriverVerified,
  editProviderMeta: useEditProviderMeta,
  sendDriverInvite: useSendDriverInvite,
  exportReservations: useExportReservations,
  addOrganisation: useAddOrganisation,
  exportInvitations: useExportInvitations,
  remitDriverInvoices: useRemitDriverInvoices,
  invoiceReservation: useInvoiceReservation,
  downloadBulkInvites: useDownloadBulkInvites,
  bulkInviteUpload: useBulkInviteUpload,
  updateOrganisationCommissions: useUpdateOrganisationCommissions,
  updateOrganisationProviders: useUpdateOrganisationProviders,
  updateOrganisationMobilityProduct: useUpdateOrganisationMobilityProduct,
  exportOrganisationStatistics: useOrganisationStatisticsCSV,
  bulkBusinessCardsUpload: useBulkBusinessCardsUpload,
  updateOrganisationEmailTemplates: useUpdateOrganisationEmailTemplates,
  updateOrganisationUsageFeeConfig: useUpdateOrganisationUsageFeeConfig,
  addTransactionRuleGroup: useAddTransactionRuleGroup,
  updateTransactionRuleGroup: useUpdateTransactionRuleGroup,
  deleteTransactionRuleGroup: useDeleteTransactionRuleGroup,
};

export { UseMutation, UseQuery };
